import { withStyles } from '@material-ui/core';
import React from 'react';
import Colours from '../../styles/colours';
import Button from './button';

const styles = {
  root: {
    marginBottom: 4
  }
};

const OutlineButton = withStyles(styles)(({ classes, className, ...other }) => (
  <Button
    variant="outline"
    flat={true}
    small={true}
    forceClassName={true}
    forceStyle={true}
    className={className + ' ' + classes.root}
    {...other}
  />
));

export default OutlineButton;
export { OutlineButton };
